import {AsyncLoadResult} from "../../../shared/abstractStore";
import {useLazyQuery} from "@apollo/react-hooks";
import gql from "graphql-tag";
import {mainApiConfig} from "../../../configure/mainApiConfig";
import React from "react";
import {claimEndUserQuery} from "../generated/claimEndUserQuery";
import {ClaimQueryOptions} from "./useMyClaim";


export function useClaimEndUserDetails(options: ClaimQueryOptions): AsyncLoadResult<claimEndUserQuery> {

    const [load, {loading, error, data, refetch}] = useLazyQuery(
        gql`
            query claimEndUserQuery($id: String!){
                item: claim(id: $id){
                    id,
                    number,
                    endUserEmail,
                    endUserMobile,
                    endUserName,
                    endUserPhone,
                    registeredAddress,
                    deliveryAddress,
                    externalReference,
                    policyNumber,
                    state {
                        id,
                        name,
                        status,
                        trackerStep,
                        trackerNumber,
                    }
                    repairFinishedEvent: events(eventName: "Awaiting Repaired Equipment Return to End User") {
                        id,
                        name,
                        eventDate
                    }
                }
            }
        `, {
            variables: {id: options.id},
            fetchPolicy: options.fetchPolicy ?? mainApiConfig.defaultFetchPolicy,
            pollInterval: options.pollInterval,
            onCompleted: (data) => {
                if (options.onCompleted){
                    options.onCompleted(data);
                }
            }
        }
    )

    // Run the query (unless we are being lazy).
    React.useEffect(() => {
        if (!options.lazy) {
            load();
        }
    }, [options.lazy, load])

    const refresh = React.useCallback(
        async () => {!refetch ? await load() : await refetch();},
        [refetch, load]);

    return React.useMemo(() => ({
        data: data ?? ({} as any),
        refresh: refresh,
        isLoading: loading,
        errors: error
    }), [data, refresh, loading, error]);

}
